import React from 'react';
import { Avatar, Ic, fmtNum } from './ui';
import BotSwitcher from './BotSwitcher';

/**
 * Bot seçici — API eskisiyle aynı: { bots, selected, onSelect, extra }
 * Masaüstü: Telegram tarzı çipler (satır kırılır, yana kaydırma yok).
 * Mobil: 3+ botta tek "bot değiştir" düğmesi + alttan açılan liste (yana kaydırma yok).
 */
export default function BotSelector({ bots = [], selected, onSelect, extra = null }) {
  if (!bots.length) return null;
  const many = bots.length > 2;
  const unread = {};
  bots.forEach(b => { if (b.pending_reports > 0) unread[b.id] = b.pending_reports; });
  const selBot = bots.find(b => b.id === selected?.id || b.id === selected) || null;
  return (
    <div className={'bot-sel' + (many ? ' many' : '')}>
      <style>{`
        .bot-chips { display:flex; flex-wrap:wrap; gap:8px; align-items:center; }
        .bot-chip { display:inline-flex; align-items:center; gap:9px; padding:4px 14px 4px 4px; border-radius:22px; border:1px solid var(--border3); background:var(--surface); color:var(--text); cursor:pointer; font:inherit; font-size:14px; font-weight:500; max-width:260px; min-width:0; transition:background .12s, border-color .12s; }
        .bot-chip:hover { background:var(--hover, #202b36); }
        .bot-chip.on { background:var(--active, #2b5278); border-color:var(--active, #2b5278); color:#fff; }
        .bot-chip .cnt { font-size:12px; color:var(--text3); }
        .bot-chip.on .cnt { color:#cfe0f1; }
        .bot-sel-m { display:none; }
        @media (max-width: 768px) {
          .bot-chip { max-width:100%; }
          .bot-sel.many .bot-chips { display:none; }
          .bot-sel.many .bot-sel-m { display:flex; gap:8px; align-items:center; flex-wrap:wrap; }
        }
      `}</style>
      <div className="bot-chips">
        {bots.map(bot => {
          const on = selected?.id === bot.id || selected === bot.id;
          return (
            <button key={bot.id} className={'bot-chip' + (on ? ' on' : '')} onClick={() => onSelect(bot)} title={bot.name}>
              <Avatar id={bot.id} name={bot.name} size={30}>
                {bot.bot_type === 'date' ? <Ic n="heart" s={16} /> : null}
              </Avatar>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{bot.name}</span>
              {bot.user_count != null && <span className="cnt">{fmtNum(bot.user_count)}</span>}
              {bot.pending_reports > 0 && (
                <span style={{ background: 'var(--danger)', color: '#fff', fontSize: 11, borderRadius: 10, padding: '0 6px', fontWeight: 700, lineHeight: '18px' }}>{bot.pending_reports}</span>
              )}
            </button>
          );
        })}
        {extra}
      </div>
      {many && (
        <div className="bot-sel-m">
          <BotSwitcher bots={bots} selected={selBot} onSelect={onSelect} unread={unread} style={{ flex: '1 1 220px' }}
            sub={selBot?.user_count != null ? `${fmtNum(selBot.user_count)} kullanıcı · ${bots.length} bot` : `${bots.length} bot`} />
          {extra}
        </div>
      )}
    </div>
  );
}
